import { Grid, Stack, Typography } from '@mui/material';
import PageSection from '../shared/PageSection';
import type {
  Alert,
  Camera,
  Detection,
  IdentityProfile,
  IdentityVerification,
  Subject,
  Tenant,
  WebhookEndpoint,
} from '../../app/types';

interface DashboardPageProps {
  readonly tenant?: Tenant | null;
  readonly cameras: Camera[];
  readonly subjects: Subject[];
  readonly alerts: Alert[];
  readonly detections: Detection[];
  readonly webhooks: WebhookEndpoint[];
  readonly identityProfiles: IdentityProfile[];
  readonly identityVerifications: IdentityVerification[];
}

export default function DashboardPage(props: DashboardPageProps) {
  const cards = [
    { label: 'Active Cameras', value: props.cameras.length },
    { label: 'Watchlist Subjects', value: props.subjects.length },
    { label: 'Open Alerts', value: props.alerts.filter((alert) => alert.status === 'open').length },
    { label: 'Detections', value: props.detections.length },
    { label: 'Enabled Webhooks', value: props.webhooks.filter((webhook) => webhook.enabled).length },
    { label: 'Identity Profiles', value: props.identityProfiles.length },
    { label: 'Identity Checks', value: props.identityVerifications.length },
  ];

  return (
    <Stack spacing={3}>
      <PageSection
        title="Mission Overview"
        subtitle={props.tenant ? `Current tenant: ${props.tenant.displayName}` : 'Tenant scope is not loaded yet.'}
      >
        <Typography variant="body1" color="text.secondary">
          This console is wired to the current platform API. Operators can register cameras, upload snapshots,
          curate watchlist subjects, review detections and alerts, manage webhook delivery settings, and run
          tenant-scoped identity verification from one place.
        </Typography>
      </PageSection>

      <Grid container spacing={2}>
        {cards.map((card) => (
          <Grid item xs={12} sm={6} lg={4} key={card.label}>
            <PageSection title={String(card.value)} subtitle={card.label}>
              <Typography variant="body2" color="text.secondary">
                Real-time counts derived from the active tenant scope.
              </Typography>
            </PageSection>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
